import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/currency-list';
import ListGroupHeaderComponent from './components/currency-group-list-header';
import ViewComponent from './components/currency-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from "./components/currency-form-new";
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateCurrencyComponent from "./components/aggregate-currency";
import normalizeNumber from "../../import/normalize/normalize-number";
import FieldNumberViewInImport from "../../import/view-in-preview/number-view-in-import";

export default class CurrencyCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);

        this.formulaCompatible = true;
    }

    /*listItemGroupFunction() {
        return i=>{
            const value = i.item.customFieldsData[this.customField.id];
            return value ? value : 0;
        }
    }*/

    _getCurrencyMark() {
        const currencyId = this.customField.params ? this.customField.params.symbol : null;
        let currencyMark = '';

        for (let availableCurrId in gd.const.currency) {
            if (availableCurrId === currencyId)  {
                currencyMark = gd.const.currency[availableCurrId].symbol;
                break;
            }
        }

        return currencyMark;
    }

    _getNormalizedValue(value) {
        const decimalPlaces = this.customField.params ? this.customField.params.decimalPlaces : 0;
        const normalized = typeof value === 'number' ? value : parseFloat(value);
        return isNaN(normalized) ? null : normalized.toLocaleString('en', { useGrouping:true, minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
    }

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !!customFieldsData[this.customField.id] ? this._getNormalizedValue(customFieldsData[this.customField.id]) : '';
    }

    getValue(item) {return item.customFieldsData[this.customField.id]}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => {
                    const value = i.item.customFieldsData[this.customField.id]
                    const number = typeof value === 'string' ? parseFloat(value) : value
                    return !_.isNil(number) && !_.isNaN(number) ? number : 0
                }
            ],
            directions: ['asc', sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    get AggregateComponent() {
        return AggregateCurrencyComponent.bind(null, this.getAggregateOptions(), this.customField.params);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeNumber(value);
    }

    getComponentViewInImport() {
        return FieldNumberViewInImport;
    }
}